import { parseUploadSizeToBytes } from "./parseUploadSize";

/**
 * Find files larger than the configured max size.
 * @param fileList List of files
 * @param maxSize Max allowed size (e.g. "10MB", "1G") or legacy MB number
 * @returns list of big file names
 */
function findBigFiles(fileList: File[], maxSize: string | number = 2) {
  const maxBytes =
    typeof maxSize === "number"
      ? maxSize * 1024 * 1024
      : parseUploadSizeToBytes(maxSize);
  const threshold = maxBytes ?? 10 * 1024 * 1024;
  const bigFiles = new Set<string>();

  for (const file of fileList) {
    if (file.size >= threshold) {
      bigFiles.add(file.name);
    }
  }

  return Array.from(bigFiles);
}

export default findBigFiles;
